__turbopack_context__.v({
  "foodScoreElement": "OXbrmG_foodScoreElement",
  "foodTextContent": "OXbrmG_foodTextContent",
  "root": "OXbrmG_root",
});
